const backend = {
    baseURL: `${process.env.VUE_APP_API_URL}api/`
}

export default backend